import {
  ISelectWeightStep,
  IWeightAndColor,
  IWizardStep,
} from 'fitbeat.gym-core';
import { EquipmentWeight } from 'fitbeat.models';
import React from 'react';
import { ScrollView, StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { connect } from 'react-redux';
import { defaultScale } from '../utils/scaling';
import { RadioButtonAndEquipmentSelection } from './RadioButtonAndEquipmentSelection';
import { selectAnswer } from './selectors';

interface IOwnProps {
  currentStep: IWizardStep<ISelectWeightStep>;
  weigthTextStyle?: TextStyle;
  weightOptionContainerStyle?: ViewStyle;
  isSelected(index: number, answer: number): boolean;
  selectWeight(index: number, currentStep: IWizardStep<ISelectWeightStep>): void;
  getWeightAndColor(equipmentWeight: EquipmentWeight): IWeightAndColor;
}

interface IStateProps {
  answer: number;
}

type IProps = IOwnProps & IStateProps;

export const SelectWeightComponent: React.FunctionComponent<IProps> = ({
  currentStep,
  selectWeight,
  answer,
  isSelected,
  getWeightAndColor,
  weigthTextStyle,
  weightOptionContainerStyle,
}) => {
  const weightOptions = currentStep.config.weightOptions;
  return (
    <ScrollView contentContainerStyle={styles.container}>
      {weightOptions.map((equipmentWeight, index) => {
        return (
          <RadioButtonAndEquipmentSelection
            key={equipmentWeight}
            weightAndColor={getWeightAndColor(equipmentWeight)}
            weightOptionContainerStyle={weightOptionContainerStyle}
            weigthTextStyle={weigthTextStyle}
            isSelected={isSelected(index, answer)}
            toggleSelection={() => {
              selectWeight(index, currentStep);
            }}
          />
        );
      })}
    </ScrollView>
  );
};

const mapStateToProps = (state, ownProps) => {
  return { answer: selectAnswer(state, ownProps.currentStep) };
};

export const SelectWeight: React.FC<IOwnProps> = connect(
  mapStateToProps,
)(SelectWeightComponent);
const styles = StyleSheet.create({
  container: {
    paddingTop: defaultScale(10),
  },
});
